import type { RouteObject } from 'react-router'
import { AssessmentsPage, AssessmentWorkbenchPage } from './Assessments'
import { AuditPage } from './Audit'
import { CalendarPage } from './Calendar'
import { CasePage } from './Case'
import { CoveragePage, WorkspaceCompanyPage } from './Coverage'
import { DashboardPage } from './Dashboard'
import { EngagementsPage } from './Engagements'
import { InboxPage } from './Inbox'
import { MeetingPage } from './Meeting'
import { ReportsPage } from './Reports'
import { ReviewPage } from './Review'
import { SignalsPage } from './Signals'

/**
 * Routes under /workspace. To add a screen: create `<Screen>.tsx` in this folder, add a line
 * here, and (for top-level screens) an entry in ./nav.ts. Detail pages such as
 * `companies/:id` need only the route.
 */
export const workspaceRoutes: RouteObject[] = [
  { index: true, element: <DashboardPage /> },
  { path: 'inbox', element: <InboxPage /> },
  { path: 'coverage', element: <CoveragePage /> },
  { path: 'companies/:id', element: <WorkspaceCompanyPage /> },
  { path: 'engagements', element: <EngagementsPage /> },
  { path: 'engagements/:id', element: <CasePage /> },
  // Review queue and dashboard links use /workspace/cases/:id.
  { path: 'cases/:id', element: <CasePage /> },
  { path: 'assessments', element: <AssessmentsPage /> },
  { path: 'assessments/new', element: <AssessmentWorkbenchPage /> },
  { path: 'assessments/:id', element: <AssessmentWorkbenchPage /> },
  { path: 'review', element: <ReviewPage /> },
  { path: 'signals', element: <SignalsPage /> },
  { path: 'calendar', element: <CalendarPage /> },
  { path: 'meetings/:id', element: <MeetingPage /> },
  { path: 'reports', element: <ReportsPage /> },
  { path: 'audit', element: <AuditPage /> },
]
